"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
/**
 * Combines elements into one row, where all elements are the same height, do
 * not have a gutter or a border radius in between.
 */
const Compound = ({ children }) => {
    const classes = useStyles();
    return react_1.default.createElement("div", { className: classes.root }, children);
};
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        display: 'flex',
        '& > *:not(:last-child)': {
            flexGrow: 1,
            '&, & .rfc-input': {
                borderTopRightRadius: '0 !important',
                borderBottomRightRadius: '0 !important',
            },
        },
        '& > * + *': {
            borderTopLeftRadius: '0 !important',
            borderBottomLeftRadius: '0 !important',
        },
        '& > *': {
            margin: '0 !important',
        },
    },
});
exports.default = Compound;
